import { render } from "./ChevronLeftIcon.vue?vue&type=template&id=5f6e0860"
import script from "./ChevronLeftIcon.vue?vue&type=script&lang=js"
export * from "./ChevronLeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__